module.exports = __webpack_public_path__ + "assets/img/1601_03.jpg?9ac52904518cc1be9def0084f91e5383";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1601_03.jpg
// module id = 1097
// module chunks = 0